import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { SharedService } from 'app/shared/services/shared.service';
import { HttpService } from 'app/shared/services/http.service';
import { DictionaryService } from 'app/shared/services/dictionary.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';

@AutoUnsubscribe()
@Component({
  selector: 'user-settings-component',
  templateUrl: './user-settings.component.html',
  styleUrls: ['./user-settings.component.scss'],
})
export class UserSettingsComponent implements OnInit {
  public oldPassword: string;
  public newPassword: string;
  public newPasswordConfirm: string;
  public subscriptions: Array<any>;

  constructor(
    public router: Router,
    public location: Location,
    public sharedService: SharedService,
    public httpService: HttpService,
    public dictionaryService: DictionaryService,
    public ga: GoogleAnalyticsService
  ) {
    this.subscriptions = [];
  }

  ngOnDestroy() {}

  ngOnInit() {
    this.sharedService.setPageTitle('USER_SETTINGS');
  }

  validateForm() {
    let isValid = true;
    if (this.sharedService.isEmpty(this.oldPassword)) {
      isValid = false;
      this.sharedService.showFlashMessage(
        this.dictionaryService.get('CURRENT_PASSWORD') + ' ' + this.dictionaryService.get('IS_REQUIRED'),
        'error'
      );
    } else if (this.sharedService.isEmpty(this.newPassword)) {
      isValid = false;
      this.sharedService.showFlashMessage(
        this.dictionaryService.get('NEW_PASSWORD') + ' ' + this.dictionaryService.get('IS_REQUIRED'),
        'error'
      );
    } else if (!this.sharedService.validatePassword(this.newPassword)) {
      isValid = false;
      this.sharedService.showFlashMessage(this.dictionaryService.get('INVALID_PASSWORD'), 'error');
    } else if (this.sharedService.isEmpty(this.newPasswordConfirm)) {
      isValid = false;
      this.sharedService.showFlashMessage(
        this.dictionaryService.get('CONFIRM_NEW_PASSWORD') + ' ' + this.dictionaryService.get('IS_REQUIRED'),
        'error'
      );
    } else if (this.newPassword !== this.newPasswordConfirm) {
      isValid = false;
      this.sharedService.showFlashMessage(this.dictionaryService.get('NEW_AND_CONFIRM_PASSWORD_DONT_MATCH'), 'error');
    }
    return isValid;
  }

  save() {
    if (this.validateForm()) {
      this.changePassword();
    }
  }

  changePassword() {
    const params = {
      user_data: {
        new_password: this.newPassword,
        password: this.oldPassword,
        repeat_new_password: this.newPassword,
      },
    };
    this.subscriptions.push(
      this.httpService.post('users_management/changePassword', params).subscribe(
        (response) => {
          if (response.success) {
            this.sharedService.showFlashMessage(this.dictionaryService.get('SETTINGS_SAVED_SUCCESSFULLY'), 'success');
          } else {
            this.sharedService.showErrorFlashMessage(response.errors);
          }
        },
        (error) => {
          this.sharedService.showErrorFlashMessage();
        }
      )
    );
  }

  cancel() {
    this.location.back();
  }
}
